(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/collections/boards.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/collections/boards.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const rulesRadio = svs.numbergames.game_model.rulesRadio;
svs.numbergames.game_model.collections.Boards = Backbone.Collection.extend({
  model: svs.numbergames.game_model.models.Board,
  initialize(attr) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.productId = options.productId;
    this.isPackage = options.isPackage;
    this.isSystem = options.isSystem;
    this.noEmptyBoards = options.noEmptyBoards;
    this.isNewBoards = false;
    this.listenTo(this, 'change:isActive', this.isActiveChanged);
  },
  isActiveChanged(model, isActive) {
    if (!isActive) return;
    let activeBoards = this.where({
      isActive: true
    });
    activeBoards = activeBoards.filter(board => board !== model);
    activeBoards.forEach(board => {
      board.set({
        isActive: false
      });
    });

    this.trigger('active:board:changed', model, true);
  },
  add(models) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rules = rulesRadio.request('rules');
    const addOptions = {
      add: true,
      remove: false,
      merge: false,
      parse: true
    };
    const defaults = {
      productId: this.productId,
      isPackage: this.isPackage,
      isSystem: this.isSystem
    };
    if (Array.isArray(models)) {
      models = models.map(model => _objectSpread(_objectSpread({}, defaults), model));
    } else if (models && typeof models === 'number') {
      let i = models;
      models = [];
      while (i--) {
        models.push(_objectSpread({}, defaults));
      }
    } else if (typeof models === 'object') {
      models = _objectSpread(_objectSpread({}, defaults), models);
    } else {
      models = _objectSpread({}, defaults);
    }
    const result = this.set(models, _objectSpread(_objectSpread({}, addOptions), options));
    if (options.preHuxfluxed > this.length) this.add(options.preHuxfluxed - this.length);
    for (let i = 0; i < options.preHuxfluxed; i++) {
      var _rules$levels;
      ((_rules$levels = rules.levels) === null || _rules$levels === void 0 ? void 0 : _rules$levels.preset) && this.at(i).set('level', rules.levels.preset);
    }
    if (options.preHuxfluxed) {
      this.preHuxfluxBoards = options.preHuxfluxed;
    }
    let active = this.findWhere({
      isActive: true
    });
    if (!active && this.size()) {
      active = this.findWhere({
        isValid: true
      });
      if (!active) active = this.first();
      active.set({
        isActive: true
      }, {
        silent: true
      });
    }
    return Array.isArray(result) ? result : [result];
  },
  activateNext(currentBoard) {
    if (!currentBoard) currentBoard = this.getActive();
    const nextBoard = this.next(currentBoard);
    if (nextBoard) nextBoard.set({
      isActive: true
    });
    return nextBoard;
  },
  next(currentBoard) {
    const rules = rulesRadio.request('rules');
    if (!currentBoard) currentBoard = this.getActive();
    const index = this.indexOf(currentBoard);
    const last = this.last(this.size() - index);
    const first = this.first(index);
    const models = last.concat(first);
    let next = _.find(models, model => model.get('isEmpty'));
    if (!next && this.size() < rules.maxNumberOfRows) {
      var _this$add = this.add();
      var _this$add2 = _slicedToArray(_this$add, 1);
      next = _this$add2[0];
    }
    if (!next) next = _.find(models, model => !model.get('isValid'));
    return next;
  },
  activatePrevious(currentBoard) {
    const previousBoard = this.previous(currentBoard);
    if (previousBoard) previousBoard.set({
      isActive: true
    });
    return previousBoard;
  },
  previous(currentBoard) {
    if (!currentBoard) currentBoard = this.getActive();
    const index = this.indexOf(currentBoard);
    const first = this.first(index);
    const last = this.last(this.size() - index);
    const models = first.reverse().concat(last.reverse());
    return _.find(models, model => model.get('isValid'));
  },
  getActive() {
    return this.findWhere({
      isActive: true
    });
  },
  huxfluxAll() {
    this.each(model => model.huxflux());
    this.trigger('huxfluxedAll');
  },
  clearActive() {
    const active = this.getActive();
    if (active) active.clear();
  },
  setLength() {
    let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.length;
    while (length > this.length) this.add();
    while (length < this.length) this.pop();
  },
  getValidBoards() {
    return this.where({
      isValid: true
    });
  },
  getNumberOfValidBoards() {
    const validBoards = this.getValidBoards();
    return validBoards.reduce((count, board) => count + board.get('rowCount'), 0);
  },
  getEmptyInactiveBoards() {
    return this.where({
      isEmpty: true,
      isActive: false
    });
  },
  getNumberOfEmptyInactiveBoards() {
    return this.getEmptyInactiveBoards().length;
  },
  calculatePrice() {
    const validBoards = this.getValidBoards();
    return validBoards.reduce((accPrice, board) => accPrice + board.get('price'), 0);
  },
  generatePackageBoards(size) {
    const rules = rulesRadio.request('rules');
    let numbersExtra;
    const packageRules = rules.PACKAGES[size];
    const newBoards = [];
    const boardObject = {
      isValid: true,
      price: rules.rowPrice,
      productId: this.productId,
      rowCount: 1,
      rowPrice: rules.rowPrice
    };
    const numbers = new svs.numbergames.game_model.utils.NumberList({
      maxValue: rules.numbersMaxValue,
      maxLength: rules.numbersMaxLength
    });
    numbers.fill();
    if (rules.numbersExtraMaxLength) {
      numbersExtra = new svs.numbergames.game_model.utils.NumberList({
        maxValue: rules.numbersExtraMaxValue,
        maxLength: rules.numbersExtraMaxLength
      });
      numbersExtra.fill();
    }
    const iterator = packageRules.levels ? packageRules.levels.length : packageRules.rows;
    for (let i = 0; i < iterator; i++) {
      let level;
      if (packageRules.levels) {
        level = packageRules.levels[i];
        numbers.removeAll();
        numbers.setMaxLength(level);
        numbers.fill();
      } else {
        numbers.randomize();
        if (numbersExtra) numbersExtra.randomize();
      }
      newBoards.push(_objectSpread(_objectSpread({}, boardObject), {}, {
        level,
        hasKungKeno: packageRules.hasKungKeno,
        numbers: numbers.toArray(),
        numbersExtra: numbersExtra && numbersExtra.toArray()
      }));
    }
    this.isNewBoards = true;
    return newBoards;
  }
});

 })(window);